module.exports = __webpack_public_path__ + "static/media/autumn.5592a6e0.png";